import client from '@/plugins/axios.js'

export default  {
  getAllCampaigns(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/campaigns/campaigns')
        .then((res)=>{
          resolve(res.data.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },
  setCampaignBasket(basketPayload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/campaigns/setBasket',basketPayload)
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

}
